import packageJson from '../package.json';

export const fallbackBuildInfo = {
    version: packageJson.version,
    buildNumber: process.env.REACT_APP_BUILD_NUMBER || null,
    commitSha: process.env.REACT_APP_COMMIT_SHA || null
};

export function formatAppVersion(buildInfo = fallbackBuildInfo) {
    const version = buildInfo.version || packageJson.version;
    const details = [];

    if (buildInfo.buildNumber) {
        details.push(`build ${buildInfo.buildNumber}`);
    }

    if (buildInfo.commitSha) {
        details.push(buildInfo.commitSha.slice(0, 7));
    }

    return details.length > 0
        ? `${version} (${details.join(', ')})`
        : version;
}

export async function loadBuildInfo(fetchImpl) {
    const client = fetchImpl || (typeof fetch === 'function' ? fetch : null);

    if (typeof client !== 'function') {
        return fallbackBuildInfo;
    }

    try {
        const response = await client(`/version.json?v=${Date.now()}`, {
            cache: 'no-store'
        });

        if (!response.ok) {
            return fallbackBuildInfo;
        }

        return {
            ...fallbackBuildInfo,
            ...await response.json()
        };
    } catch (error) {
        return fallbackBuildInfo;
    }
}
